import Layout from '../../components/Layout'

export default function Reports() {
  return (
    <Layout>
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-6">Reports</h1>
        <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
          <div className="text-text-muted mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <p className="text-text-secondary font-medium">Reports coming soon</p>
          <p className="text-sm text-text-muted mt-1">Analytics and reports will be available here.</p>
        </div>
      </div>
    </Layout>
  )
}
